import ProfileScreen from "./profile-screen";

export default ProfileScreen;
